const namePattern = /^[A-Za-z]{3}[A-Za-z0-9]*(?: [A-Za-z]{3}[A-Za-z0-9]*)*$/;

const validations = {
  password: {
    min: {
      value: 8,
      message: "Password should be atleast 8 characters!",
    },
    max: {
      value: 32,
      message: "Password should not be more than 32 characters!",
    },
    pattern: {
      value: /^(?=.{8,}$)(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*\W).*$/,
      message:
        "Password should contain atleast 1 uppercase, 1 lowercase, 1 number and 1 special character",
    },
  },
  phone: {
    minLength: {
      value: 10,
      message: "Please enter a valid Phone Number!",
    },
    maxLength: {
      value: 10,
      message: "Please enter a valid Phone Number!",
    },
    pattern: {
      value: /^[0-9]*$/,
      message: "Please enter a valid Phone Number!",
    },
  },
  firstName: {
    minLength: {
      value: 3,
      message: "First name should be atleast 3 characters!",
    },
    maxLength: {
      value: 36,
      message: "First name should not be more than 36 characters!",
    },
    pattern: {
      value: namePattern,
      message:
        "First name should start with 3 letters and contain only letters, numbers, and single spaces!",
    },
  },
  lastName: {
    maxLength: {
      value: 36,
      message: "Last Name should not be more than 36 characters!",
    },
    pattern: {
      value: namePattern,
      message:
        "Last name should start with 3 letters and contain only letters, numbers, and single spaces!",
    },
  },
  email: {
    pattern: {
      value: /^[A-Za-z][\w.-]*@([\w-]+\.)+[\w-]{2,}$/,
      message: "Please enter a valid email!",
    },
    minLength: {
      value: 3,
      message: "Email should be more than 3 characters!",
    },
  },
  storeName: {
    minLength: {
      value: 3,
      message: "Store Name should be atleast 3 characters!",
    },
    maxLength: {
      value: 36,
      message: "Store Name should not be more than 36 characters!",
    },
  },
  description: {
    minLength: {
      value: 20,
      message: "Description should be atleast 20 characters!",
    },
    maxLength: {
      value: 250,
      message: "Description should not be more than 250 characters!",
    },
  },
  productDescription: {
    minLength: {
      value: 20,
      message: "Description should be atleast 20 characters!",
    },
    maxLength: {
      value: 1000,
      message: "Description should not be more than 1000 characters!",
    },
  },
  locationName: {
    minLength: {
      value: 3,
      message: "Location name should be atleast 3 characters!",
    },
    maxLength: {
      value: 100,
      message: "Location name should not be more than 100 characters!",
    },
  },
  url: {
    pattern: {
      value:
        /(https:\/\/www\.|http:\/\/www\.|https:\/\/|http:\/\/)?[a-zA-Z]{2,}(\.[a-zA-Z]{2,})(\.[a-zA-Z]{2,})?\/[a-zA-Z0-9]{2,}|((https:\/\/www\.|http:\/\/www\.|https:\/\/|http:\/\/)?[a-zA-Z]{2,}(\.[a-zA-Z]{2,})(\.[a-zA-Z]{2,})?)|(https:\/\/www\.|http:\/\/www\.|https:\/\/|http:\/\/)?[a-zA-Z0-9]{2,}\.[a-zA-Z0-9]{2,}\.[a-zA-Z0-9]{2,}(\.[a-zA-Z0-9]{2,})?/g,
      message: "Please enter a valid URL!",
    },
  },
  zipCode: {
    minLength: {
      value: 4,
      message: "Zip Code should be atleast 4 characters!",
    },
    maxLength: {
      value: 10,
      message: "Zip Code should not be more that 10 characters!",
    },
  },
  optionName: {
    minLength: {
      value: 3,
      message: "Option name should be atleast 3 characters!",
    },
    maxLength: {
      value: 100,
      message: "Option name should not be more than 100 characters!",
    },
  },
  price: {
    pattern: {
      //value: /^\d*\.?\d*$/,
      value: /^(?!0+(\.0+)?$|0\.1$|-)\d+(\.\d+)?$/,
      message: "Please enter a valid value!",
    },
  },
  costPerItem: {
    pattern: {
      value: /^(?:0|[1-9]\d*)(?:\.\d+)?$/,
      message: "Please enter a valid value!",
    },
  },
};

export const createNameValidation = (label) => {
  return {
    minLength: {
      value: 3,
      message: `${label} should be atleast 3 characters!`,
    },
    maxLength: {
      value: 36,
      message: `${label} should not be more than 36 characters!`,
    },
  };
};

export default validations;
